// services/preferencesService.js
import api from './api';

class PreferencesService {
  // Get all user preferences
  async getUserPreferences() {
    try {
      const response = await api.get('/preferences');
      return response.data;
    } catch (error) {
      console.error('Error fetching user preferences:', error);
      throw error;
    }
  }

  // Update user preferences (partial update)
  async updatePreferences(preferences) {
    try {
      const response = await api.patch('/preferences', preferences);
      return response.data;
    } catch (error) {
      console.error('Error updating preferences:', error);
      throw error;
    }
  }

  // Update calendar toggles specifically
  async updateCalendarToggles(toggles) {
    try {
      const response = await api.patch('/preferences/calendar-toggles', toggles);
      return response.data;
    } catch (error) {
      console.error('Error updating calendar toggles:', error);
      throw error;
    }
  }

  // Update budget view type
  async updateBudgetViewType(viewType) {
    try {
      const response = await api.patch('/preferences/budget-view', { viewType });
      return response.data;
    } catch (error) {
      console.error('Error updating budget view type:', error);
      throw error;
    }
  }

  // Update actions view type
  async updateActionsViewType(viewType) {
    try {
      const response = await api.patch('/preferences/actions-view', { viewType });
      return response.data;
    } catch (error) {
      console.error('Error updating actions view type:', error);
      throw error;
    }
  }

  // Convenience methods for specific toggles
  async toggleCalendarItem(itemName, isVisible) {
    try {
      const toggleUpdate = { [itemName]: isVisible };
      return await this.updateCalendarToggles(toggleUpdate);
    } catch (error) {
      console.error(`Error toggling calendar ${itemName}:`, error);
      throw error;
    }
  }
}

export default new PreferencesService();
